<template>
  <div class="breadcrumbbar" v-if="currentRouteName">
    <div class="row align-items-center">
      <div class="col-md-8 col-lg-8">
        <h4 class="page-title">{{breadcrumpinfo.title}}</h4>
        <div class="breadcrumb-list">
          <ol class="breadcrumb">
            <li class="breadcrumb-item" v-for="(item, index) in breadcrumpinfo.items" v-bind:key="index">
              <span class="active" v-if="isLast(index)">{{ showName(item) }}</span>
              <router-link :to="item" v-else>{{ showName(item) }}</router-link>
            </li>
          </ol>
        </div>
      </div>
      <div class="col-md-4 col-lg-4">
        <!--div class="widgetbar">
          <button class="btn btn-primary-rgba">
            <i class="feather icon-plus mr-2"></i>Actions
          </button>
        </div-->
      </div>
    </div>
   
  </div>
</template>

<script>

export default {

  
  computed:{
    
   currentRouteName() {
    
        return this.$route.name;
    },
    breadcrumpinfo() {
       if(this.$route && this.$route.name){
this.setPaths();

     }
        return this.$store.state.breadCrump;
    }
  },

  methods: {

    setPaths(){
    
    let me = this;
   
   var items =[];
  function getItem(routename){
for(var i = 0; i<me.$router.options.routes.length;i++){
      var item =me.$router.options.routes[i];
      if(item.name==routename){
        items.push(item);
        me.$store.state.breadCrump.title = item.meta.label;
        break;
      }
    }

  }
  if(!me.$route){
return;

  }
  if(me.$route.name !="route-index" )
  getItem("route-index");
    
if(me.$route.name.includes('-edit')){
   getItem(me.$route.name.replace('-edit','-list'));
}
  
    getItem(me.$route.name);
    
me.$store.state.breadCrump.items = items
 
  },
    isLast(index) {
      return index === this.breadcrumpinfo.items.length - 1;
    },
    showName(item) {
      if (item.meta && item.meta.label) {
        item = item.meta && item.meta.label;
      }
      if (item.name) {
        item = item.name;
      }
      return item;
    },
  },
};
</script>
